import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE_CONFIG } from "../../config/site";
import { useCalendly } from "./CalendlyModal";

const COLS = [
  {
    title: "Soluciones",
    links: [
      { label: "Consultoría", to: "/consultoria-tecnologica" },
      { label: "Aplicaciones", to: "/consultoria-aplicaciones" },
      { label: "Software", to: "/software" },
      { label: "IA", to: "/inteligencia-artificial" },
      { label: "Automatización", to: "/automatizacion" },
    ],
  },
  {
    title: "Tecnología",
    links: [
      { label: "APIs", to: "/integracion-apis" },
      { label: "Cloud", to: "/infraestructura-cloud" },
      { label: "Ciberseguridad", to: "/ciberseguridad" },
      { label: "Data", to: "/inteligencia-artificial" },
    ],
  },
  {
    title: "Empresa",
    links: [
      { label: "Nosotros", to: "/nosotros" },
      { label: "Proyectos", to: "/proyectos" },
      { label: "Contacto", to: "/contacto" },
    ],
  },
];

const Placeholder = ({ label }) => (
  <span className="mono text-xs text-[var(--muted)]/70">{label}: <span className="text-[var(--cyan)]/70">por configurar</span></span>
);

export const Footer = () => {
  const { openCalendly } = useCalendly();
  return (
    <footer className="relative border-t border-[var(--line)] bg-[var(--bg2)]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1.2fr]">
          <div>
            <Link to="/" className="flex items-center gap-2.5" data-testid="footer-logo">
              <span className="w-2.5 h-2.5 rounded-[3px] bg-gradient-to-br from-[var(--green)] to-[var(--blue)]" />
              <span className="text-lg font-extrabold tracking-tight">Netsys<span className="text-gradient"> Panamá</span></span>
            </Link>
            <p className="mt-4 text-sm text-[var(--muted)] max-w-xs leading-relaxed">Tecnología para construir lo que sigue.</p>
            <button
              onClick={openCalendly}
              className="btn-glow mt-6 inline-flex items-center gap-1.5 rounded-full bg-[var(--surface2)] px-5 py-2.5 text-sm font-semibold"
              data-testid="footer-cta-agendar"
              data-cursor="cta"
            >
              Agendar una reunión <ArrowUpRight size={15} className="text-[var(--green)]" />
            </button>
          </div>

          {COLS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="mono text-[11px] tracking-[0.3em] uppercase text-[var(--green)] mb-4">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-[var(--muted)] hover:text-[var(--ink)] transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div>
            <h3 className="mono text-[11px] tracking-[0.3em] uppercase text-[var(--green)] mb-4">Contacto</h3>
            <ul className="space-y-2.5 text-sm text-[var(--muted)]">
              <li>{SITE_CONFIG.location}</li>
              <li>{SITE_CONFIG.email ? <a href={`mailto:${SITE_CONFIG.email}`} className="hover:text-[var(--ink)]">{SITE_CONFIG.email}</a> : <Placeholder label="Email" />}</li>
              <li>{SITE_CONFIG.phone ? <a href={`tel:${SITE_CONFIG.phone.replace(/[\s-]/g, "")}`} className="hover:text-[var(--ink)]">{SITE_CONFIG.phone}</a> : <Placeholder label="Teléfono" />}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-[var(--line)] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="mono text-xs text-[var(--muted)]">© {new Date().getFullYear()} Netsys Panamá</p>
          <p className="mono text-xs text-[var(--muted)]/60">DISEÑAMOS LO QUE SIGUE.</p>
        </div>
      </div>
    </footer>
  );
};
